export default [
  {
    'icon': 'tachometer-alt',
    'title': {ck: 'dashboard', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine'
  },
  {
    'icon': 'book',
    'title': {ck: 'manuals', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/manuals'
  },
  {
    'icon': 'chart-network',
    'title': {ck: 'schematics', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/schematics'
  },
  {
    'icon': 'wrench',
    'title': {ck: 'troubleshooting', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/troubleshooting'
  },
  {
    'icon': 'clock',
    'title': {ck: 'serviceHistory', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/history'
  },
  {
    'icon': 'bobcaticon-faultcodes',
    'title': {ck: 'faultcodes', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/faultcodes'
  },
  {
    'icon': 'bobcaticon-fieldmods',
    'title': {ck: 'fieldmods', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/fieldmods'
  },
  {
    'icon': 'code-branch',
    'title': {ck: 'controllerversions', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/controller-versions'
  },
  {
    'icon': 'shield-check',
    'title': {ck: 'warranty', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/warranty'
  },
  {
    'icon': 'map-marker-alt',
    'title': {ck: 'locationHistory', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/locationhistory'
  },
  {
    'icon': 'plus-circle',
    'title': {ck: 'builtOptions', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/options'
  },
  {
    'icon': 'calendar-exclamation',
    'title': {ck: 'maintenance', cp: 'mymachine_InPageNavigation'},
    'path': '/mymachine/maintenance'
  },
  {
    'icon': 'bobcaticon-salesforce',
    'title': {ck: 'salesforce', cp: 'mymachine_InPageNavigation'},
    'link': {ck: 'salesforceLink', cp: 'mymachine_InPageNavigation'},
    'region': ['EMEA', 'ALAO']
  }
]
